const compareUrls = (url1, url2) => {
  try {
    const parsedUrl1 = new URL(url1);
    const parsedUrl2 = new URL(url2);
    if (parsedUrl1.protocol !== parsedUrl2.protocol || parsedUrl1.hostname !== parsedUrl2.hostname || parsedUrl1.port !== parsedUrl2.port) {
      return false;
    }
    const path1 = parsedUrl1.pathname.replace(/\/$/, "");
    const path2 = parsedUrl2.pathname.replace(/\/$/, "");
    if (path1 !== "" && path2 !== "" && path1 !== path2) {
      return false;
    }
    return true;
  } catch (error) {
    console.error("Invalid URL(s)", error);
    return false;
  }
};
export {
  compareUrls
};
//# sourceMappingURL=compareUrls.mjs.map